"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSettingsDialog = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../");

var _helpers = require("../../util/helpers");

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

var _TRCToggle = _interopRequireDefault(require("../../TRCToggle"));

var _color = _interopRequireDefault(require("color"));

var _saveVideoSettings = require("./saveVideoSettings");

require("../VideoPlayer/VideoContainer.css");

var _excluded = ["open", "zoomEnabled", "loopMomentPlay", "speed", "muted", "locked", "onClose", "onConfirmSettingsChange", "videoSettingsKey", "setLoop", "setLocked"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Vars
var SPEED_VALUES = [{
  id: 0,
  value: 0.5,
  text: ".5x"
}, {
  id: 1,
  value: 1,
  text: "1x"
}, {
  id: 2,
  value: 1.5,
  text: "1.5x"
}, {
  id: 3,
  value: 2,
  text: "2x"
}]; // Video Settings Dialog

var VideoSettingsDialog = function VideoSettingsDialog(_ref) {
  var open = _ref.open,
      zoomEnabled = _ref.zoomEnabled,
      loopMomentPlay = _ref.loopMomentPlay,
      speed = _ref.speed,
      muted = _ref.muted,
      locked = _ref.locked,
      onClose = _ref.onClose,
      onConfirmSettingsChange = _ref.onConfirmSettingsChange,
      videoSettingsKey = _ref.videoSettingsKey,
      setLoop = _ref.setLoop,
      setLocked = _ref.setLocked,
      props = _objectWithoutProperties(_ref, _excluded);

  // Some state
  var _useState = (0, _react.useState)((0, _helpers.isSmallMobileScreen)()),
      _useState2 = _slicedToArray(_useState, 2),
      isZoomEnabled = _useState2[0],
      setIsZoomEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      shouldLoopMomentPlay = _useState4[0],
      setShouldLoopMomentPlay = _useState4[1];

  var _useState5 = (0, _react.useState)(1),
      _useState6 = _slicedToArray(_useState5, 2),
      currentSpeed = _useState6[0],
      setCurrentSpeed = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isMuted = _useState8[0],
      setIsMuted = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isLocked = _useState10[0],
      setIsLocked = _useState10[1]; // Watch the props for changes


  (0, _react.useEffect)(function () {
    if (zoomEnabled !== isZoomEnabled) {
      setIsZoomEnabled(zoomEnabled);
    }
  }, [zoomEnabled]);
  (0, _react.useEffect)(function () {
    if (loopMomentPlay !== shouldLoopMomentPlay) {
      setShouldLoopMomentPlay(loopMomentPlay);
    }
  }, [loopMomentPlay]);
  (0, _react.useEffect)(function () {
    if (speed !== currentSpeed) {
      setCurrentSpeed(speed);
    }
  }, [speed]);
  (0, _react.useEffect)(function () {
    if (muted !== isMuted) {
      setIsMuted(muted);
    }
  }, [muted]);
  (0, _react.useEffect)(function () {
    if (locked !== isLocked) {
      setIsLocked(locked);
    }
  }, [locked]); // Some handlers

  var handleOnClose = function handleOnClose(e) {
    if (e) {
      e.preventDefault();
    }

    if (typeof onClose === "function") {
      onClose();
    }
  };

  var handleConfirmSettingsClick = function handleConfirmSettingsClick(e) {
    e.preventDefault();
    confirmSettings({}, true);
  };

  var confirmSettings = function confirmSettings(changes) {
    var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var settings = Object.assign({}, changes);

    if (typeof onConfirmSettingsChange === "function") {
      onConfirmSettingsChange(settings, done);
    }
  };

  var handleDidSelectSpeed = function handleDidSelectSpeed(aSpeed) {
    (0, _.trk)("VideoSettingsDialog:Speed Toggled to ".concat(speed, ":Toggle"));
    confirmSettings({
      speed: aSpeed
    });
    setCurrentSpeed(aSpeed);
  };

  var toggleMuted = function toggleMuted() {
    (0, _.trk)("VideoSettingsDialog:Mute Toggled to ".concat(!isMuted, ":Toggle"));
    confirmSettings({
      muted: !isMuted
    });
    setIsMuted(!isMuted);
  };

  var toggleLoopMomentPlay = function toggleLoopMomentPlay() {
    (0, _.trk)("VideoSettingsDialog:Loop Toggled to ".concat(!shouldLoopMomentPlay, ":Toggle")); //confirmSettings({ loopMomentPlay: !shouldLoopMomentPlay })

    setLoop(!shouldLoopMomentPlay);
    setShouldLoopMomentPlay(!shouldLoopMomentPlay);
  };

  var toggleZoom = function toggleZoom() {
    (0, _.trk)("VideoSettingsDialog:Zoom Toggled to ".concat(!isZoomEnabled, ":Toggle"));
    confirmSettings({
      zoomEnabled: !isZoomEnabled
    });
  };

  var toggleLocked = function toggleLocked() {
    //confirmSettings({ locked: !isLocked})
    setLocked(!isLocked);
    setIsLocked(!isLocked);
  };

  return /*#__PURE__*/_react.default.createElement(_.Modal, _extends({
    className: "VideoSettingsDialog",
    open: open,
    onShadeClick: function onShadeClick(e) {
      return handleOnClose(e);
    }
  }, props), /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    onCloseClick: function onCloseClick(e) {
      return handleOnClose(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_.ModalTitle, {
    content: "Video settings"
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "2"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading5,
    bold: true,
    color: "grey1-color",
    content: "Playback speed"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    justifyContent: "center",
    marginBottom: "8"
  }, SPEED_VALUES.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_molecules.Chip, {
      background: currentSpeed === item.value ? "black-color" : "grey4-color",
      color: currentSpeed === item.value ? "white2-color" : "black-color",
      onClick: function onClick() {
        return handleDidSelectSpeed(item.value);
      },
      content: item.text,
      marginRight: "2",
      marginLeft: "2",
      paddingTop: "2",
      paddingBottom: "2",
      key: item.id,
      fat: true
    });
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "2"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading5,
    bold: true,
    color: "grey1-color",
    content: "Game sound"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "8"
  }, /*#__PURE__*/_react.default.createElement(_TRCToggle.default, {
    checked: !isMuted,
    onToggle: function onToggle() {
      return toggleMuted();
    }
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "2"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Heading5,
    bold: true,
    color: "grey1-color",
    content: "Loop highlight play"
  })), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    marginBottom: "2"
  }, /*#__PURE__*/_react.default.createElement(_TRCToggle.default, {
    checked: shouldLoopMomentPlay,
    onToggle: function onToggle() {
      return toggleLoopMomentPlay();
    }
  }))), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    primary: true,
    content: "Confirm settings",
    onClick: function onClick(e) {
      return handleConfirmSettingsClick(e);
    },
    trk: "VideoSettingsDialog:ConfirmSettings Pressed:Button"
  })));
};

exports.VideoSettingsDialog = VideoSettingsDialog;
VideoSettingsDialog.defaultProps = {
  open: true,
  speed: 1,
  zoomEnabled: (0, _helpers.isSmallMobileScreen)(),
  loopMomentPlay: true,
  muted: true,
  locked: true
};